import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FilledInput from '@material-ui/core/FilledInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import Cookies from 'js-cookie';

import API_PATH from "../../constants/config.json";
import { setCookie } from '../../functions/Auth';
import { Container, CssBaseline } from '@material-ui/core';
import '../../scss/components/_user_details.scss';
import ErrorMessage from '../AppLayouts/ErrorMessage';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const AddStation = (props) => {

   

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="userdetails-main">
                <Container className="adduser-container" maxWidth="lg">
                    <div>
                        <div className="details-top">
                            <div>
                                <p>
                                    <label className="section-title">Add user</label>
                                </p>
                                <p className="section-description">Create a new user with the information below</p>
                            </div>
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setShowAddStation(false)} />
                        </div>
                        
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AddStation;